export default {
  pessoas_fisica: [],
  pessoa_fisica: {},
  pagination: {},
};
